import { type FC, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { Colors } from "@snapchat/snap-design-system";
import { ArrowRightIcon, CheckIcon, Sizes } from "@snapchat/snap-design-system-icons";

import { type GoogleProtobufTimestamp } from "../../../../gql-generated/types";

import styles from "./EnrolledProgram.module.css";
import { ViewInMonetization } from "./messages.generated";

export interface EnrolledPanelProps {
    lensId: string;
    unlockableId: string;
    lensName: string;
    markedAsExclusiveAt?: GoogleProtobufTimestamp | null;
    monetizationUrl: string;
    onViewInMonetization: () => void;
}

interface ProgramEnrolledPanelProps extends Pick<EnrolledPanelProps, "monetizationUrl" | "onViewInMonetization"> {
    title: ReactNode;
    description: ReactNode;
    children: ReactNode;
}

export const ProgramEnrolledPanel: FC<ProgramEnrolledPanelProps> = ({
    title,
    description,
    monetizationUrl,
    onViewInMonetization,
    children,
}) => (
    <section className={styles.enrolledPanel}>
        <Group className={styles.enrolledHeader}>
            <Group className={styles.programTitleGroup}>
                <ThemeIcon className={styles.enrolledIcon}>
                    <CheckIcon fill={Colors.WHITE} size={Sizes.Medium} />
                </ThemeIcon>
                <div>
                    <Text component="h4" className={styles.programTitle}>
                        {title}
                    </Text>
                    <Text className={styles.description}>{description}</Text>
                </div>
            </Group>
            <Button
                component={Link}
                to={monetizationUrl}
                onClick={onViewInMonetization}
                className={styles.viewInMonetization}
                rightSection={<ArrowRightIcon size={Sizes.Small} />}
            >
                <ViewInMonetization />
            </Button>
        </Group>
        <Stack className={styles.panelContent}>{children}</Stack>
    </section>
);
